module.exports = __webpack_public_path__ + "static/media/search.95b1f8dc.svg";